import * as types from "../actions/types/billPayment.types";

const initialState = {
    billerData: {
        billerCode: null,
        billerName: "",
    },
    getBillerTypeState: "idle",
    packageData: {},
    packageName: "",
    payTvBillsState: "idle",
    serviceName: "",
    billProviderData: {},
    viewPackage: false,
    viewAmount: false,
    kudaBillerTypes: [],
    kudaBillerDetails: [],
    getBillerDetailsState: "idle",
    initiateBillPaymentState: "idle",
    initiateBillPaymentData: {},
    billersList: [],
};

export const billPaymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_TV_BILLER:
            return {
                ...state,
                serviceName: action.payload,
                billProviderData: state.kudaBillerDetails.find((o) => o.name === action.payload),
                viewPackage: true,
            };
        case types.SET_PACKAGE_BILLER:
            return {
                ...state,
                packageData: { ...state.packageData, ...action.payload },
                viewAmount: true,
            };
        case types.GET_BILLERS_STARTED:
            return {
                ...state,
                getBillerTypeState: "loading",
            };
        case types.GET_BILLERS_SUCCEEDED:
            return {
                ...state,
                getBillerTypeState: "success",
                kudaBillerTypes: action.payload,
            };
        case types.GET_BILLERS_FAILED:
            return {
                ...state,
                getBillerTypeState: "failed",
            };
        case types.GET_BILLER_DETAILS_STARTED:
            return {
                ...state,
                getBillerDetailsState: "loading",
            };
        case types.GET_BILLER_DETAILS_SUCCEDEED:
            return {
                ...state,
                kudaBillerDetails: action.payload,
                getBillerDetailsState: "success",
            };
        case types.GET_BILLER_DETAILS_FAILED:
            return {
                ...state,
                getBillerDetailsState: "failed",
            };
        case types.PAY_TV_BILLS_STARTED:
            return {
                ...state,
                payTvBillsState: "loading",
            };
        case types.PAY_TV_BILLS_SUCCEEDED:
            return {
                ...state,
                payTvBillsState: "success",
            };
        case types.PAY_TV_BILLS_FAILED:
            return {
                ...state,
                payTvBillsState: "failed",
                tvErrorMsg: action.payload,
            };
        case types.RESET_TV:
            return {
                ...state,
                serviceName: "",
                packageData: {},
                billProviderData: {},
                payTvBillsState: "initial",
                packageName: "",
                viewPackage: false,
                viewAmount: false,
            };
        case types.INITIATE_BILL_PAYMENT_STARTED:
            return {
                ...state,
                initiateBillPaymentState: "loading",
            };
        case types.INITIATE_BILL_PAYMENT_SUCCEDEED:
            return {
                ...state,
                initiateBillPaymentState: "success",
                initiateBillPaymentData: action.payload,
            };
        case types.INITIATE_BILL_PAYMENT_FAILED:
            return {
                ...state,
                initiateBillPaymentState: "failed",
            };
        case types.GET_BILLERS_LIST_SUCCEEDED:
            return {
                ...state,
                billersList: action.payload,
            };
        default:
            return state;
    }
};
